import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Suspense } from "react";
import ScrollToTop from "./components/ScrollToTop";
import Index from "./pages/Index";
import RouteLoader from "./components/RouteLoader";
import { lazyWithRetry as lazy } from "./lib/lazyWithRetry";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";

// Lazy load all pages except Index for code splitting
const Calculator = lazy(() => import("./pages/Calculator"));
const Contact = lazy(() => import("./pages/Contact"));
const DespreNoiSolyra = lazy(() => import("./pages/DespreNoiSolyra"));
const TermeniConditii = lazy(() => import("./pages/TermeniConditii"));
const PoliticaConfidentialitate = lazy(() => import("./pages/PoliticaConfidentialitate"));
const PoliticaCookie = lazy(() => import("./pages/PoliticaCookie"));
const NotFound = lazy(() => import("./pages/NotFound"));
const SolyraProtect = lazy(() => import("./pages/SolyraProtect"));
const SolyraProtectPartners = lazy(() => import("./pages/SolyraProtectPartners"));
const SolyraProtectBusiness = lazy(() => import("./pages/SolyraProtectBusiness"));
const Servicii = lazy(() => import("./pages/Servicii"));
const Recomanda = lazy(() => import("./pages/Recomanda"));
const LandingPage = lazy(() => import("./pages/LandingPage"));
const Unsubscribe = lazy(() => import("./pages/Unsubscribe"));
const OfertaGenerata = lazy(() => import("./pages/OfertaGenerata"));


const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <Suspense fallback={null}>
      <Toaster />
      <Sonner />
    </Suspense>
    <BrowserRouter>
      <ScrollToTop />
      <Suspense fallback={<RouteLoader />}>
        <Routes>
          <Route path="/" element={<Index />} />

          {/* Main pages */}
          <Route path="/calculator" element={<Calculator />} />
          <Route path="/solyra-protect" element={<SolyraProtect />} />
          <Route path="/solyra-protect-parteneri" element={<SolyraProtectPartners />} />
          <Route path="/solyra-protect-business" element={<SolyraProtectBusiness />} />
          <Route path="/servicii" element={<Servicii />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/despre-solyra" element={<DespreNoiSolyra />} />
          <Route path="/termeni-conditii" element={<TermeniConditii />} />
          <Route path="/politica-confidentialitate" element={<PoliticaConfidentialitate />} />
          <Route path="/politica-cookie" element={<PoliticaCookie />} />
          <Route path="/recomanda" element={<Recomanda />} />
          <Route path="/analiza-gratuita" element={<LandingPage />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
          <Route path="/oferta-generata" element={<OfertaGenerata />} />

          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  </QueryClientProvider>
);

export default App;
